<template><div><h1>VUX V2.1.0Rc.50 released</h1>
<h2><a href="/en/components/popup-picker.html">PopupPicker</a></h2>
<ul><li>[fix] Fix no on-change emits #934 @howyhuang</li>
</ul>
<h2><a href="/en/components/swipeout.html">Swipeout</a></h2>
<ul></ul></div></template><script>
export default {
  head: {"title":"VUX V2.1.0Rc.50 released | VUX - Vue.js Mobile UI Component Framework","ignoreSuffixChar":"|"}
}
  </script>


// WEBPACK FOOTER //
// v2.1.0-rc.50-72.vue?e1abb27c